import { useTranslation } from 'react-i18next';
import Breadcrumbs from '@app/components/breadcrumbs/Breadcrumbs';
import { BREADCRUMB_IDS } from '@app/configs/breadcrumbs';
import { ROUTES } from '@app/configs/routes';
import LoanApplication from '@modules/borrower/components/loanApplication/LoanApplication';
const LoanApplicationPage = () => {
    const { t } = useTranslation();
    const breadcrumbsItems = [
        {
            id: BREADCRUMB_IDS.LOAN_APPLICATION,
            label: t('financing.breadcrumbs.loan_application'),
            path: ROUTES.loanApplication,
        },
    ];
    return (<div className="px-4 pb-4 md:px-6 md-pb-6 flex-col leading-5">
            <div className="pb-4 leading-5 font-medium">
                <Breadcrumbs items={breadcrumbsItems} activeBreadcrumb={BREADCRUMB_IDS.LOAN_APPLICATION} type="borrower"/>
            </div>
            <LoanApplication />
        </div>);
};
export default LoanApplicationPage;
